<template>
    <div id="rating-scale-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                v-model="item.ratingScale.fieldLabel"
                @input="setFieldLabel(item.ratingScale.fieldLabel)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: align === 'left' }" @click="setAlignment('left')">{{ $t("form.left") }}</button>
                <button class="button" :class="{ active: align === 'right' }" @click="setAlignment('right')">{{ $t("form.right") }}
                </button>
                <button class="button" :class="{ active: align === 'top' }" @click="setAlignment('top')">{{ $t("form.top") }}</button>
            </div>
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle" @click="toggleVisibility">
                <span class="toggle-option" :class="{ active: visibility }">{{ visibility ? 'Görünür' : 'Gizli' }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="ratingScale"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

<!--        <div class="form-field">-->
<!--            <label class="form-label">Zorunlu</label>-->
<!--            <div class="toggle">-->
<!--                <span class="toggle-option" :class="{ active: required }" @click="toggleRequired">{{ required ? 'AÇIK' : 'KAPALI' }}</span>-->
<!--            </div>-->
<!--            <small class="form-description">Bu alan boşsa formun gönderilmesine izin vermeyin</small>-->
<!--        </div>-->

        <div class="form-field">
            <label class="form-label">{{ $t('form.subLabel1') }}</label>
            <input
                type="text"
                class="form-input"
                v-model="item.ratingScale.subLabelOne"
                @input="setSubLabelOne(item.ratingScale.subLabelOne)"
            >
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t('form.subLabel2') }}</label>
            <input
                type="text"
                class="form-input"
                v-model="item.ratingScale.subLabelTwo"
                @input="setSubLabelTwo(item.ratingScale.subLabelTwo)"
            >
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "RatingScaleSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldLabel: this.item.ratingScale.fieldLabel,
            align: this.item.ratingScale.align,
            subLabelOne: this.item.ratingScale.subLabelOne,
            subLabelTwo: this.item.ratingScale.subLabelTwo,
            defaultAlign: true,
            required: false,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            updateTimer: null,

        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setAlignment(alignment) {
            this.align = alignment;
            this.$emit("update-alignment-rating-scale", alignment);
            this.updateFields();
        },
        toggleRequired() {
            this.required = !this.required;
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateFields();
            this.$emit('update-visibility', this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        duplicateField() {
            console.log("Alan kopyalandı");
        },
        setFieldLabel(label) {
            this.fieldLabel = label;
            this.$emit("update-field-label-rating-scale", label);
            this.updateFields();
        },
        setSubLabelOne(label) {
            this.subLabelOne = label;
            this.$emit("update-sub-label-one-rating-scale", label);
            this.updateFields();
        },
        setSubLabelTwo(label) {
            this.subLabelTwo = label;
            this.$emit("update-sub-label-two-rating-scale", label);
            this.updateFields();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    visibility: self.visibility,
                    slug: self.slug,
                    ratingScale: {
                        fieldLabel: self.fieldLabel,
                        align: self.align,
                        subLabelOne: self.subLabelOne,
                        subLabelTwo: self.subLabelTwo,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.ratingScale) { return; }
                this.fieldLabel = val.ratingScale.fieldLabel;
                this.align = val.ratingScale.align;
                this.subLabelOne = val.ratingScale.subLabelOne;
                this.subLabelTwo = val.ratingScale.subLabelTwo;
                this.visibility = typeof val.visibility !== 'undefined' ? val.visibility : this.visibility;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.ratingScale.fieldLabel': function (v) { this.fieldLabel = v; },
        'item.ratingScale.align': function (v) { this.align = v; },
        'item.ratingScale.subLabelOne': function (v) { this.subLabelOne = v; },
        'item.ratingScale.subLabelTwo': function (v) { this.subLabelTwo = v; },
        'item.ratingScale.rating': function () {},
        'item.visibility': function (v) { this.visibility = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>

<style lang="scss" scoped>
#rating-scale-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #10b981;
                    color: #ffffff;
                    border-color: #10b981;
                    box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }
    }
}
</style>
